<script>
export default {
    name: 'IconMoreHorizontal'
}
</script>
<template>
    <svg
        class="base-icon icon-more-horizontal"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 28a4 4 0 110 8 4 4 0 010-8zm-16 0a4 4 0 110 8 4 4 0 010-8zm32 0a4 4 0 110 8 4 4 0 010-8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
